module.exports = __webpack_public_path__ + "static/media/transf2.79972c6f.jpg";